import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ValueByKeyPipe} from './value.by.key.pipe';
import {ValuesByKeysPipe} from './values.by.keys.pipe';

@NgModule({
    imports: [
        CommonModule
    ],
    declarations: [
        ValueByKeyPipe,
        ValuesByKeysPipe
    ],
    exports: [
        ValueByKeyPipe,
        ValuesByKeysPipe
    ]
})
export class DashboardPipesModule {

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/pipes/pipes.module.ts